import React, { useContext, useState } from "react";
import clsx from "clsx";
import { defineMessages, useIntl } from "react-intl";
import { ListItem, Divider, TextField, makeStyles } from "@material-ui/core";
import { FormContext } from "./form";
import { useFormStyles } from "./formFields";
import { activityUseStyles } from "./activityFormField";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { isImage } from "../common/attachments/attachmentsHelper";

const messages = defineMessages({
    additionalDetails: {
        id: "task-complete-form.attachment-additional-details",
        defaultMessage: "Additional details",
        description: "Additional details",
    },
});

const useStyles = makeStyles((theme) => ({
    extension: {
        paddingTop: "15px",
        display: "inline-block",
    },
    imgContainer: {
        padding: "0px 5px",
        "&:hover": {
            cursor: "pointer",
        },
    },
    imgStyle: {
        height: "50px",
        width: "50px",
        borderRadius: "4px",
    },
    newFileHeader: {
        display: "flex",
    },
    fileName: {
        flex: 1,
    },
    thumbnail: {
        height: "50px",
        width: "50px",
        borderRadius: "4px",
    },
    detailsParent: {
        textAlign: "left",
        display: "flex",
        padding: 0,
        width: "100%",
        margin: "auto",
    },
    details: {
        paddingRight: "12px",
        color: "#999999",
    },
    detailsWithVal: {
        color: "#555555",
    },
}));

export const AttachmentEntryEdit = (props) => {
    const formServices = useContext(FormContext);
    const { file, onChange } = props;
    const intl = useIntl();
    const [fileEntry, setFileEntry] = useState(file);
    const [valueDetails, setValueDetails] = useState(file.fileDescription); // Replace with retrieved description eventually
    const [value, setValue] = useState(file.fileDescription); // Value to actually display after clicking "done"
    const classes = Object.assign(activityUseStyles(), useStyles(), useFormStyles());

    const onDetChange = (event) => {
        const val = event.target.value;
        var newFile = { ...fileEntry };
        newFile.fileDescription = val;
        setFileEntry(newFile);
        onChange(newFile);
        setValueDetails(val);
    };

    // Sets value only when clicking 'done'
    const onDetailsEntered = (event) => {
        setValue(valueDetails);
    };

    const imageDetails = () => {
        return (
            <div className={classes.detailsParent}>
                <span className={clsx({ [classes.details]: !valueDetails, [classes.detailsWithVal]: valueDetails })}>
                    {valueDetails ? valueDetails : intl.formatMessage(messages.additionalDetails)}{" "}
                    <EditIcon style={{ marginTop: "-6px", height: "0.75em", width: "0.75em" }} color="primary" />
                </span>
            </div>
        );
    };

    return (
        <>
            <ListItem>
                <div className={classes.formElement}>
                    <div className={classes.imgContainer} onClick={props.handleAttachmentSelect}>
                        {isImage(file.fileType) && <img className={classes.thumbnail} src={`data:${file.fileType};base64,${file.data}`} />}
                    </div>
                    <div className={classes.formInfo}>
                        <div className={clsx(classes.infoHeader, classes.newFileHeader)}>
                            <TextField
                                className={classes.fileName}
                                variant="outlined"
                                value={fileEntry.fileName}
                                error={!fileEntry.fileName.trim()}
                                InputProps={{
                                    inputProps: { maxLength: 255 },
                                }}
                                onChange={(event) => {
                                    var newFile = { ...fileEntry };
                                    newFile.fullFileName = event.target.value + "." + fileEntry.extension;
                                    newFile.fileName = event.target.value;
                                    setFileEntry(newFile);
                                    onChange(newFile);
                                }}
                            />
                            <span className={classes.extension}>.{file.extension}</span>
                        </div>
                        <div className={classes.formResult}>
                            {props.editorProps &&
                                formServices.edit({
                                    ...props.editorProps,
                                    icon: imageDetails(),
                                    value: valueDetails,
                                    activity: true, // Need to use the activity styling
                                    onChange: onDetChange,
                                    btnCallback: onDetailsEntered,
                                    characterCount: props.characterCountEnabled ? (valueDetails ? valueDetails.length : "0") : null,
                                })}
                        </div>
                    </div>
                    <div className={classes.formQtyDelete}>
                        <DeleteIcon color="primary" className={classes.formDelete} onClick={() => props.removeNewRow(file.id)} />
                    </div>
                </div>
            </ListItem>
            <Divider />
        </>
    );
};

export default AttachmentEntryEdit;
